export enum GroupsApi {
  Groups = '/api/v2.0/usercontact/group',
  GroupContacts = '/api/v2.0/usercontact/group/:groupId/contacts',
  CreateGroup = '/api/v2.0/usercontact/group',
  DeleteGroups = '/api/v2.0/usercontact/group',
  EditGroup = '/api/v2.0/usercontact/group',
  AddContactsToGroup = '/api/v2.0/usercontact/group/:id',
  RemoveContactsFromGroup = '/api/v2.0/usercontact/group/:id'
}

export enum AdminGroupsApi {
  Groups = '/api/v1.0/groups',
  Group = '/api/v1.0/groups/:groupId',
  GroupUsers = '/api/v1.0/groups/:groupId/users'
}

export enum AdminV2GroupsApi {
  Groups = '/api/v2/admin/groups',
  CopyGroupsFromUsers = '/api/v2/admin/groups/getGroupsFromUsers'
}
